import homeownersInsuranceSteps from './homeownersInsurance';
import { RouteSteps } from '../types';

const steps: RouteSteps = {
  homeowners: homeownersInsuranceSteps,
};

export default steps;
